import Script from 'next/script';

const script = `(
  function(w,d,s,l,i) {
    var PWT = {};
    w[l]=w[l]||[];
    var gptRan = false;
    PWT.jsLoaded = function() {
      loadGPT();
    };
    var loadGPT = function() {
      if (!gptRan) {
        gptRan = true;
        w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),
        dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      }
    };

    setTimeout(loadGPT, 500);
  }) (window,document,'script','dataLayer','GTM-KBRSC8K');`;

export function GoogleTagManagerNoScript(): JSX.Element {
  return (
    <noscript>
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KBRSC8K" height="0" width="0">
        <style jsx>{`
          iframe {
            display: none;
            visibility: hidden;
          }
        `}</style>
      </iframe>
    </noscript>
  );
}

export default function GoogleTagManager(): JSX.Element {
  return (
    <>
      <Script
        id="google-tag-manager-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{ __html: script }}
      />
    </>
  );
}
